import React, {Component} from 'react';
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import AttivitaCompletate from './AttivitaCompletate'
import '../../styles/AttivitaUserContainer.css'
import PropTypes from 'prop-types';
class AttivitaUtenteDelGiorno extends Component {

    constructor(props) {
        super(props);
        this.state = {
            idUtente: props.idUtente,
            attivitaComplete: [],
            attivitaCorrente: undefined,
            attivitaPrecedente: undefined,
            giorno: props.giorno,
            _loading: false,
            error: null,
        };
        this.loadData = this.loadData.bind(this)
    }

    componentDidMount() {
        this.loadData();
    }

    componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.giorno !== this.props.giorno || nextProps.idUtente !== this.props.idUtente){
            this.setState({idUtente: nextProps.idUtente, giorno: nextProps.giorno}, this.loadData)
        }
    }

    loadData() {
        this.setState({_loading: true});
        client.loadAttivitaUtente(this.state.idUtente, this.state.giorno).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{

                    let completate = data.items.filter((item)=>{
                        return (item.fine !== null);
                    })

                    let corrente = data.items.filter((item)=>{
                        return item.fine === null;
                    })
                    if (corrente.length > 0){
                        corrente = corrente[0];
                    }
                    else {
                        corrente = undefined;
                    }
                    let precedente = undefined;
                    if (completate.length > 0){
                        precedente = completate[completate.length - 1];
                    }
                    this.setState({
                        attivitaComplete: completate,
                        attivitaCorrente: corrente,
                        attivitaPrecedente: precedente,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });

    }

    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }
        return (<AttivitaCompletate
            items={this.state.attivitaComplete}
            giorno={this.state.giorno}
            loading={this.state._loading}
            showProgress={false}
        />)
    }
}

AttivitaUtenteDelGiorno.contextTypes = {
    router: PropTypes.object
}

AttivitaUtenteDelGiorno.PropTypes = {
    giorno: PropTypes.string.isRequired,
    idUtente: PropTypes.number.isRequired,
}

AttivitaUtenteDelGiorno.defaultProps = {
};


export default AttivitaUtenteDelGiorno;




/** WEBPACK FOOTER **
 ** ./src/components/attivita/AttivitaUtenteDelGiorno.js
 **/